<template>
    <div class="page-notice page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">小程序公告</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>公告管理</el-breadcrumb-item>
                            <el-breadcrumb-item>小程序公告</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleNotice('add')">添加 <i class="el-icon-plus"></i></el-button>
                    <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
                            <el-table-column prop="title" align="center" label="公告标题" min-width="220">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.title"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="content" align="center" label="公告内容" min-width="120">
                                <template slot-scope="scope">
                                    <a href="javascript:;" class="show-content" @click="dlg_content.visible=true;dlg_content.content=scope.row.content;dlg_content.title=scope.row.title">预览</a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m_time" align="center" label="修改时间" min-width="180">
                            </el-table-column>
                            <el-table-column prop="c_time" align="center" label="创建时间" min-width="180">
                            </el-table-column>
                            <el-table-column prop="status_name" align="center" label="状态" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleNotice('edit',scope.row)">编辑</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteNotice(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export notice-dialog" :title="dlg_notice.title" :visible.sync="dlg_notice.visible" width="1000px" @closed="closeNotice" :close-on-click-modal="false">
            <el-form ref="formNotice" :model="dlg_notice.form" label-width="120px" :rules="dlg_notice.rules" @submit.native.prevent>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="title" label="公告标题：" :error="dlg_notice.error.title">
                            <el-input size="small" v-model="dlg_notice.form.title" placeholder='请输入公告标题' clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="status" label="状态：" :error="dlg_notice.error.status">
                            <el-radio-group v-model="dlg_notice.form.status">
                                <el-radio v-for="(item, index) in dlg_notice.init_data.status_list" :key="index" :label="item.id">{{item.name}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
               <!-- <el-form-item prop="content" label="公告内容：" :error="dlg_notice.error.content">
                    <el-input v-model="dlg_notice.form.content" type="textarea" :rows="10" size="small" placeholder="请输入公告内容"></el-input>
                </el-form-item>-->
                <div class="notice-editor"><my-editor ref="editor" :content_text.sync="editor_content"></my-editor></div>
                <p class="red-tips">*公告内容推荐放一张图片(宽为400最佳),通过上方菜单最右侧的图片上传来上传，不要直接复制粘贴图片</p>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_notice.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitNotice()" :loading="dlg_notice.btn_loading">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog class="dialog-export preview-dialog" :title="dlg_content.title" :visible.sync="dlg_content.visible" width="600px" :close-on-click-modal="false">
            <div class="ql-container ql-snow">
                <div v-html="dlg_content.content" class="preview-content ql-editor">{{dlg_content.content}}</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                baseUrl:this.$client.IMG_URL,
                multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
                editor_content:'',
                dlg_notice:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
                    init_data:{
                        status_list: []
                    },
                    form:{
                        title:'',
                        content:'',
                        status:1
                    },
                    error:{
                        title:'',
                        status:''
                    },
                    reset_form: {},
                    rules:{
                        title:{required: true, message: '请输入公告标题', trigger: ['change','blur']},
                        status:{required: true, message: '请选择状态', trigger: ['change','blur']}
                    }
                },
                dlg_content:{
                    visible:false,
                    content:'',
                    title:''
                }
            }
        },
        created() {
            document.title = '小程序公告';
            this.dlg_notice.reset_form = Object.assign({}, this.dlg_notice.form);
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = {};
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                var status_default = [{id:-1, name: '全部'}];
                _this.table_data.loading = true;
                this.$client.get('/adminapi/notice/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.dlg_notice.init_data.status_list = res.status_name_list;
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要删除的公告");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                var params = {id:idList.join(",")}
                this.$confirm('确定要批量删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/notice/delete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            handleNotice(type,data){
                this.dlg_notice.visible = true;
                if(type == 'add'){
                    this.dlg_notice.title = '添加公告';
                    this.dlg_notice.api = '/adminapi/notice/save';
                }else{
                    this.dlg_notice.id= data.id;
                    this.dlg_notice.title = '编辑公告';
                    if(data){
                        for(var key in this.dlg_notice.form){
                            this.dlg_notice.form[key] = data[key];
                        }
                        this.editor_content = data.content;
                    }
                    this.dlg_notice.api = '/adminapi/notice/save?id=' + data.id;
                }
            },
            deleteNotice(id){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/notice/delete', {id:id}, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            submitNotice(){
                var _this = this;
                _this.$refs['formNotice'].validate((valid) => {
                    if (valid) {
                        this.dlg_notice.form.content = this.$refs.editor.content;
                        this.dlg_notice.btn_loading = true;
                        this.$client.post(this.dlg_notice.api, this.dlg_notice.form, function(res,message){
                            //console.log(res)
                            _this.$message(message);
                            _this.getList();
                            _this.dlg_notice.btn_loading = false;
                            _this.dlg_notice.visible = false;
                        }, function(message){
                            //console.log(111)
                            _this.dlg_notice.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_notice.error[key] = message[key];
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            closeNotice(){
                this.editor_content = '';
                this.dlg_notice.btn_loading = false;
                for(var key in this.dlg_notice.form){
                    this.dlg_notice.form[key] = this.dlg_notice.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formNotice.clearValidate();
            })
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>
    .page-notice .el-upload--picture-card{
        line-height: 80px;
    }
    .page-notice .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 80px;
        height: 80px;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }
    .notice-editor .quill-editor{
        height: 400px !important;
    }
</style>
<style scoped>
    .ql-container.ql-snow{
        border: none;
    }
    .show-content{
        color: #ff6d33;
    }
    .show-content:hover{
        color: #FFA784;
    }
    .preview-content{
        max-height: 400px;
        overflow-y: auto;
        line-height: 22px;
    }
    .red-tips{
        color: #F31A5C;
        font-size: 12px;
        padding-top: 10px;
    }
</style>